/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Input, Skeleton, Switch, Table } from 'antd';
import moment from 'moment';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { COMMON_DATE_FORMAT, PACKAGE_TYPE, StatusFilterType } from '../../../../shared/constants/commonConstants';
import { INVENTORY_MASTER_PACKAGE_MAPPING } from '../../../../shared/constants/urlEndPoints';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { formatPrice } from '../../../../utils/utility';
import { ReactComponent as ApprovedIcon } from '../../../../assets/images/svg/i_approved.svg';
import { ReactComponent as PendingIcon } from '../../../../assets/images/svg/i_pending.svg';
import { ReactComponent as RejectedIcon } from '../../../../assets/images/svg/i_rejected.svg';
import NoDataFound from '../../shared/NoDataFound';

const MasterPackages = ({ onSelection }: any): ReactElement => {
  const [masterPackages, setMasterPackages] = useState(null as any);
  const [dataSource, setDataSource] = useState(null as any);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecord, setTotalRecord] = useState(2);
  const [isLoading, setIsLoading] = useState(false);
  let timeout: any;
  useEffect((): void => {
    const payload = {
      mappingByTypeName: true,
      fetchPackageDetail: true,
    };
    fetchMasterPackages(payload);
  }, []);

  useEffect((): void => {
    if (masterPackages && masterPackages.length) {
      mapDataSource();
    } else {
      setDataSource(null);
    }
  }, [masterPackages]);

  useEffect((): void => {
    if (currentPage) {
      fetchMasterPackages({});
    }
  }, [currentPage]);

  const fetchMasterPackages = async (reqPayload: any): Promise<void> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_MASTER_PACKAGE_MAPPING;
    const payload = {
      mappingByTypeName: true,
      fetchPackageDetail: true,
      pageNumber: currentPage,
      pageSize,
      typeNames: [
        PACKAGE_TYPE.HEALTHCHECK,
      ],
      packageName: '',
      ...reqPayload,
    };
    setIsLoading(true);
    const res: any = await SendRequest.instance.post(url, payload);
    setIsLoading(false);
    if (res && res.isSuccess && res.mappingDetails) {
      setMasterPackages(res.mappingDetails);
      setTotalRecord(2);
    } else {
      setMasterPackages(null);
    }
  };

  const onPaginationEvent = (page: number, pgSize: any): void => {
    setCurrentPage(page);
    setPageSize(pgSize);
  };

  const onSearch = (e: any): void => {
    clearTimeout(timeout);
    timeout = setTimeout((): void => {
      setCurrentPage(1);
      if (e && e.length >= 3) {
        const reqpayload: any = {
          packageName: e,
          pageNumber: 1,
          mappingByPackageName: true,
        };
        fetchMasterPackages(reqpayload);
      } else if (!e) {
        fetchMasterPackages({});
      }
    }, 500);
  };

  const columns = [
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      render: (e: any, record: any): any => <Switch size="small" checked={record?.active} />,
    },
    {
      title: 'Name',
      dataIndex: 'packageName',
      key: 'packageName',
    },
    {
      title: 'Age Range',
      dataIndex: 'ageRange',
      key: 'ageRange',
      render: (e: any, record: any): any => <p style={{ width: 100 }}>{record.ageRange}</p>,
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (e: any, record: any): any => <p style={{ width: 100 }}>{record.price}</p>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any): ReactNode => {
        switch (record.status) {
          case StatusFilterType.isApproved:
            return <div className="status verified" style={{ width: 100 }}>
              <ApprovedIcon className="fill-approved v-align-sub" /> Verified
            </div>;
          case StatusFilterType.isSubmit:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-pending v-align-sub" /> Pending
            </div>;
          case StatusFilterType.isRejected:
            return <div className="status rejected" style={{ width: 100 }}>
              <RejectedIcon className="fill-rejected v-align-sub" /> Rejected
            </div>;
          default:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-approved v-align-sub" /> Pending
            </div>;
        }
      },
    },
    {
      title: 'Last Updated',
      dataIndex: 'lastUpdated',
      key: 'lastUpdated',
      render: (e: any, record: any): any => <p style={{ width: 100 }}>{record.lastUpdated}</p>,
    },
  ];

  const mapDataSource = (): void => {
    const data = masterPackages.map(({ hcltPackageDetail: x }: any): any => {
      return {
        key: x.id,
        packageName: x.packageName,
        active: x.isActive,
        ageRange: `${x.minAge} - ${x.maxAge}`,
        price: formatPrice(x.price, false),
        status: x.statusName,
        lastUpdated: moment(x.modifiedOn).format(COMMON_DATE_FORMAT),
        item: x,
      };
    });
    setDataSource(data);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="mb-lg w-100">
        <Input placeholder="Search master package"
          allowClear={true}
          style={{ width: '30%', float: 'right' }}
          ref={(input: any): any => input && input.focus()}
          onChange={(e: any): any => onSearch(e.target.value)} />
      </div>
      {(dataSource && dataSource.length > 0 && !isLoading) &&
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            defaultPageSize: pageSize,
            defaultCurrent: currentPage,
            total: totalRecord, onChange: (page: number, pagesize: any): any => onPaginationEvent(page, pagesize),

          }}
          onRow={(record: any, rowIndex: any): any => {
            return {
              onClick: (): any => onSelection(record.item),
            };
          }}
        />
      }
      {isLoading && <Card><Skeleton active={true} /></Card>}
      {(!isLoading && !dataSource) && <Card> <NoDataFound /></Card>}
    </div>
  );
};

export default MasterPackages;
